import React, { useState } from "react";
// models
import { PostulacionModel, initialValuesPostulacionModel } from "../models/PostulacionesModel/postulacion.model";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// another imports
import fileDownload from "js-file-download";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { openNotification } from '../utils/Notifactions';
import DocumentosService from "../api/Documentos/api-documentos";
import getStorageUser from "../middlewares/GetStorageUser";

import { convocatoriaCerrada } from "../utils/puedeInscribirse";
import { plazoSubsanarVencido } from "../utils/subsanacion";

export const useMisPostulaciones = () => {
  const [postulaciones, setPostulaciones] = useState<any>([]);
  const [postulacionState, setPostulacionState] = useState<any>({});
  const [totalregistros, setTotalregistros] = useState<number>(0);
  const [cantidadPáginas, setCantidadPáginas] = useState<number>(10);
  const [modal, setModal] = useState<boolean>(false);
  const [lineasConvocatorias, setLineasConvocatorias] = useState<any>([]);
  const [postulacion, setPostulacion] = useState<PostulacionModel>(initialValuesPostulacionModel);
  // subsanar documentos
  const [documentosSubsanar, setDocumentosSubsanar] = useState<any>([]);
  const [totalDocumentosSubsanar, setTotalDocumentosSubsanar] = useState<number>(0);
  const [cantidadPáginasSubsanar, setCantidadPáginasSubsanar] = useState<number>(10);
  const [openModalWarning, setOpenModalWarning] = useState(false);
  const [datosFiltrados, setDatosFiltrados] = useState([])

  const onAceptar = () => {
    return setOpenModalWarning(false);
  };

  const limpiarChecksDocumentos = (postulacion: any) => {
    postulacion.documentos_administrativos?.forEach((doc: any) => {
      doc.checksubsanable = false;
      doc.checkaceptar = false;
      doc.checkcancelar = false;
      doc.checksubsanado = false;
    });
    postulacion.documentos_tecnicos?.forEach((doc: any) => {
      doc.checkaceptartecnico = undefined;
    });
  };

  const procesarVencimiento = (postulacion: any, fecha_informeRaw: any, subsanar: any[]) => {
    if (fecha_informeRaw === null || isNaN(Date.parse(fecha_informeRaw))) {
      console.error('La fecha no es válida o está indefinida:', fecha_informeRaw);
      return;
    }
    const fechaInforme = new Date(fecha_informeRaw);
    fechaInforme.setHours(fechaInforme.getHours() + 12);
    if (new Date() > fechaInforme) {
      // Solo es un pendiente real mientras el plazo de subsanación siga vigente.
      // Si ya venció no hay nada que subsanar: no se cuenta ni dispara el aviso.
      if (postulacion.estado === "Subsanar" && !plazoSubsanarVencido(postulacion)) {
        subsanar.push(postulacion);
      }
      return;
    }
    postulacion.estado = "Inscrito sin revisar";
    postulacion.observaciones = "";
    limpiarChecksDocumentos(postulacion);
  };

  const cargarPostulaciones = async (artistCall = false) => {
    try {
      const user = getStorageUser();
      let { data } = await apiParticipantes.consultarPostulaciones(user.documento);
      data = Array.isArray(data) ? data : [];
      const subsanar = [];
      setTotalregistros(data.length);

      const uniqueConvocatoriaIds = Array.from(
        new Set(data.map((p: any) => p.convocatoria_id).filter(Boolean))
      );
      const convocatoriasMap: Record<number, any> = {};
      await Promise.all(
        uniqueConvocatoriaIds.map(async (cid: any) => {
          try {
            const res = await apiConvocatorias.getConvocatoriaById(cid);
            if (res?.data) {
              convocatoriasMap[cid] = res.data;
            }
          } catch (err) {
            console.error(`Error al cargar convocatoria ${cid}:`, err);
          }
        })
      );

      for (const postulacion of data) {
        const conv = convocatoriasMap[postulacion.convocatoria_id];
        if (conv) {
          postulacion.fechas = conv.fechas;
          const fechaCierreObj = conv.fechas?.find((item: any) => item.clave === "Cierre");
          if (fechaCierreObj?.valormax) {
            postulacion.fecha_cierre = fechaCierreObj.valormax;
          }
          const cerrada = convocatoriaCerrada(conv);
          postulacion.convocatoria_cerrada = cerrada;
          postulacion.convocatoria_abierta = !cerrada;

          if (["Subsanar", "Aceptado", "Rechazado"].includes(postulacion.estado)) {
            const fecha_informeRaw = conv.fechas
              ?.filter((item: any) => item.clave === "Primer informe de verificación de documentos")[0]
              ?.valormax ?? null;
            procesarVencimiento(postulacion, fecha_informeRaw, subsanar);
          }
        }
      }

      setDatosFiltrados(data);
      setDocumentosSubsanar(subsanar);
      setTotalDocumentosSubsanar(subsanar.length);
      if (subsanar && subsanar.length > 0) setOpenModalWarning(true);
      return setPostulaciones(data);
    } catch (error) {
      console.error('Error al cargar las postulaciones:', error);
    }
  };

  const guardarArchivosAdministrativos = async (datos: any, e: any, index: number, post: Array<PostulacionModel>) => {
    try {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      let nuevosdocumentos: any = postulacionState.documentos_administrativos.map((doc: any, indexdoc: number) => {
        if (!doc.tipo_documento) doc.tipo_documento = doc.descripcion;
        if (datos.tipo_documento === doc.tipo_documento) {
          return {
            ...doc,
            url_participante: data.data,
            checksubsanable: false,
            checksubsanado: true,
          };
        }
        return {
          ...doc,
        };
      });
      let infoupdate = [...documentosSubsanar];
      for (const i in infoupdate) {
        infoupdate[i].documentos_administrativos = nuevosdocumentos;
      }
      setDocumentosSubsanar(infoupdate);
      return setPostulacionState({ ...postulacionState, documentos_administrativos: nuevosdocumentos });
    } catch (error) {
      return console.error(error);
    }
  };
  const cambiarEstadoPostulaciónDocumentos = async () => {
    let nuevaspostulaciones = postulaciones.map((data: any) => {
      if (data.id_postulacion === postulacionState.id_postulacion) {
        return postulacionState;
      }
      return data;
    });
    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
      postulacionState.id_postulacion,
      postulacionState.documentos_administrativos
    );
    let estado = "Subsanado";
    let subsanar = postulacionState.documentos_administrativos.filter((data: any) => data.checksubsanable);
    if (subsanar.length > 0) estado = "Subsanar";
    await apiParticipantes.cambiarEstadoPostulacion({
      id_postulacion: postulacionState.id_postulacion,
      estado: estado,
    });
    return setPostulaciones(nuevaspostulaciones);
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    return setCantidadPáginas(value);
  };
  const cambiarCantidadPaginasDocumentos = (e: any, value: any) => {
    return setCantidadPáginasSubsanar(value);
  };
  const descargarArchivo = async (url: string) => {
    let data: any = await DocumentosService.consultarArchivo(url);
    await fileDownload(data, url);
  };
  const obtenerLineasConvocatorias = async () => {
    let data = await apiConvocatorias.getLineaConvocatorias();
    return setLineasConvocatorias(data.data);
  }
  const verPropuesta = (datos: PostulacionModel) => {
    setPostulacion(datos);
    return setModal(true);
  }

  return {
    postulaciones,
    setPostulaciones,
    cargarPostulaciones,
    guardarArchivosAdministrativos,
    setPostulacionState,
    totalregistros,
    setTotalregistros,
    cantidadpáginas: cantidadPáginas,
    cambiarCantidadPaginas,
    documentossubsanar: documentosSubsanar,
    totaldocumentossubsanar: totalDocumentosSubsanar,
    cantidadpáginassubsanar: cantidadPáginasSubsanar,
    cambiarCantidadPaginasDocumentos,
    cambiarEstadoPostulaciónDocumentos,
    modal,
    setModal,
    descargarArchivo,
    obtenerLineasConvocatorias,
    lineasconvocatoria: lineasConvocatorias,
    postulacion,
    setPostulacion,
    verPropuesta,
    setDocumentosSubsanar,
    datosFiltrados,
    setDatosFiltrados,
    openModalWarning,
    setOpenModalWarning,
    onAceptar
  };
};
